import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import { React, useContext, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { serverInfo } from "../../../../App";
import ends from "../../../../Assets/Images/Audition-images/ends.png";
import flag from "../../../../Assets/Images/Audition-images/flag.png";
import youtube from "../../../../Assets/Images/Audition-images/Group1178.png";
import noImage from "../../../../Assets/Images/settings/no-image.png";
import "./AuditionDescription.css";

const AuditionDescription = ({ instruction, roundInfo }) => {

  const { imageCdnUrl,videoCdnUrl} = useContext(serverInfo);

  const [instructionType, setInstructionType] = useState("general");
  const [markTracking, setMarkTracking] = useState({});
  const [loading, setloading] = useState(true);

  const handleAppealedInstruction = () => {
    setInstructionType("appeal");
  };

  const handleGeneralInstruction = () => {
    setInstructionType("general");
  };

  const fetchUploadedVideo = (audition_id, round_info_id) => {
    axios
      .get(
        `api/user/audition/uploaded_round_videos/${audition_id}/${round_info_id}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          // setVideoList(res.data.videos);
          // setAppealVideoList(res.data.appeal_videos);
          setMarkTracking(res.data.auditionRoundMarkTracking);
          setloading(false);
        }
      });
  };

  useEffect(() => {
    fetchUploadedVideo(roundInfo.audition_id, roundInfo.id);
  }, [roundInfo.audition_id, roundInfo.id, roundInfo.video_slot_num]);

  useEffect(() => {
    fetchUploadedVideo(roundInfo.audition_id, roundInfo.id);
  }, [instructionType]);
  return (
    <>
      <>
        {loading === true ? (
          <>
            <h5 className="text-white justify-content-center text-center mx-auto">
              Loading...
            </h5>
          </>
        ) : (
          <>
            <div className="auditionDes">
              <>
                <div className="p-3">
                  <h4 className="text-warning">Audition Instruction</h4>
                </div>
                <div style={{ borderTop: "2px solid black" }}></div>

                <div className="d-flex justify-content-around my-3">
                  <button
                    onClick={handleGeneralInstruction}
                    className={
                      instructionType === "general"
                        ? "btnLinear"
                        : "btnLinearInactive"
                    }
                  >
                    Instruction
                  </button>

                  {roundInfo?.round_type == 1 ? (
                    <>
                      {Number(markTracking?.wining_status) == 1 ? (
                        <></>
                      ) : (
                        <>
                          <button
                            onClick={handleAppealedInstruction}
                            className={
                              instructionType == "appeal"
                                ? "btnLinear"
                                : "btnLinearInactive"
                            }
                          >
                            Appeal Instruction
                          </button>
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="bottomLineGold">
                  <img
                    src={
                      instruction?.image != null
                        ? imageCdnUrl + instruction?.image
                        : noImage
                    }
                    className="my-3"
                    style={{
                      height: "250px",
                      width: "100%",
                      borderRadius: "20px",
                      padding: "0.5rem",
                      objectFit: "cover",
                      backgroundPosition: "center",
                    }}
                    alt=""
                  />
                </div>
                <div className="p-3">
                  <h2 className="fw-bold text-center audiHeadTitle mb-3">
                    {instruction && instruction?.title}
                  </h2>
                  <p className="text-light">
                    <Markup content={instruction && instruction?.instruction} />
                  </p>
                </div>
                <div className="bottomLineGold"></div>

                <div className="bottomLineGold"></div>

                <div className="p-3 d-flex justify-content-center">
                  <ReactPlayer
                    url={videoCdnUrl + instruction?.video}
                    playing={false}
                    controls
                    maxHeight="400px"
                    className="my-3"
                    width="100%"
                  />
                </div>


{instruction?.document&& <div className="row">

                  <div className="col-md-4 mx-auto">
                    <a
                      href={videoCdnUrl + instruction?.document}
                      download="document.pdf"
                    >
                      <button className="btn btn-register  fw-bold " >
                        Download Pdf

                      </button>
                    </a>
                  </div>
                </div>}


                {instructionType === "general" ? (
                  <>
                    <div className="row justify-content-between align-items-center mx-2 my-3 mb-4">
                      <div className="col-md-4 p-2">
                        <div className="d-flex submission-bgDiv rounded-3 align-items-center p-2 ">
                          <div className="img-tag px-2">
                            <img height="40px" src={flag} alt="" />
                          </div>
                          <div className="img-tag-text">
                            <span className="text-light fw-bold">
                              Video Submission:
                            </span>
                            <br />
                            <small className="text-light">
                              Start:{" "}
                              {moment(
                                roundInfo?.video_upload_start_date
                              ).format("LL")}
                            </small>
                            <div>
                              <small className="text-light">
                                {" "}
                                End:{" "}
                                {moment(
                                  roundInfo?.video_upload_end_date
                                ).format("LL")}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 p-2">
                        <div className="d-flex round-bgDiv rounded-3 align-items-center p-2 ">
                          <div className="img-tag px-2">
                            <img height="40px" src={ends} alt="" />
                          </div>
                          <div className="img-tag-text">
                            <span className="text-light fw-bold">
                              Round Dateline:{" "}
                            </span>
                            <br />
                            <small className="text-light">
                              {moment(roundInfo?.round_start_date).format("LL")}
                            </small>
                            <div>
                              <small className="text-light">
                                {" "}
                                {moment(roundInfo?.round_end_date).format("LL")}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 p-2">
                        <div className="d-flex upload-bgDiv rounded-3 align-items-center p-2 ">
                          <div className="img-tag px-2">
                            <img height="40px" src={youtube} alt="" />
                          </div>
                          <div className="img-tag-text">
                            <span className="text-light fw-bold">
                              User upload slot
                            </span>
                            <br />
                            <h4 className="text-light">
                              {roundInfo?.video_slot_num} Video
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="row justify-content-between align-items-center mx-2 my-3 mb-4">
                      <div className="col-md-4 p-2">
                        <div className="d-flex submission-bgDiv rounded-3 align-items-center p-2 ">
                          <div className="img-tag px-2">
                            <img height="40px" src={flag} alt="" />
                          </div>
                          <div className="img-tag-text">
                            <span className="text-light fw-bold">
                              Appeal Video Submission:
                            </span>
                            <br />
                            <small className="text-light">
                              Start:{" "}
                              {moment(
                                roundInfo?.appeal_video_upload_start_date
                              ).format("LL")}
                            </small>
                            <div>
                              <small className="text-light">
                                End:{" "}
                                {moment(
                                  roundInfo?.appeal_video_upload_end_date
                                ).format("LL")}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 p-2">
                        <div className="d-flex round-bgDiv rounded-3 align-items-center p-2 ">
                          <div className="img-tag px-2">
                            <img height="40px" src={ends} alt="" />
                          </div>
                          <div className="img-tag-text">
                            <span className="text-light fw-bold">Round: </span>
                            <br />
                            <small className="text-light">
                              {moment(roundInfo?.round_start_date).format("LL")}
                            </small>
                            <div>
                              <small className="text-light">
                                {moment(roundInfo?.round_end_date).format("LL")}
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 p-2">
                        <div className="d-flex upload-bgDiv rounded-3 align-items-center p-2 ">
                          <div className="img-tag px-2">
                            <img height="40px" src={youtube} alt="" />
                          </div>
                          <div className="img-tag-text">
                            <span className="text-light fw-bold">
                              User upload slot
                            </span>
                            <br />
                            <h4 className="text-light">
                              {roundInfo?.appeal_video_slot_num} Video
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            </div>
          </>
        )}
      </>
    </>
  );
};

export default AuditionDescription;
